const {config} = require('../../../package.json');

const alias = (() => {
    return config.serviceProfile ? `/${config.serviceProfile}` : ""
})()

const mstrProject = (() => {
    return config.serviceProfile ? `Dev_RL_${config.serviceProfile.toUpperCase()}` : "Dev_RL_A"
})()

const mstrWebUrl = (() => {
    return config.serviceProfile ? `https://dev-reports-${config.serviceProfile}.rev-lock.com` :
        "https://dev-reports.rev-lock.com"
})()

const mstrServer = (()=>{
    return config.serviceProfile ? `dev-mstr-${config.serviceProfile}.cluster.rev-lock.local`: 'dev-mstr-a.cluster.rev-lock.local'
})()

function getApiEndpoint() {
    return (config['isCloudDeployment'] && `https://dev-api.rev-lock.com${alias}`) || "http://localhost:3001"
}

export default {
    microstrategy: {
        mstrWebUrl: `${mstrWebUrl}/MicroStrategy/servlet/`,
        project: mstrProject,
        server: mstrServer
    },
    hotGlue: {
        env_id: "dev.hotglue.rev-lock.com"
    },
    AWS: {
        "authenticationFlowType": "USER_PASSWORD_AUTH",
        API: {
            endpoints: [
                {
                    name: "revlock_api",
                    endpoint: getApiEndpoint()
                },
                {
                    name: "revlock_public_api",
                    endpoint: getApiEndpoint(),
                    custom_header: async () => {
                        return {'x-api-key': 'AwhpvUNsUJ7MLnfVyhXa30hwGaiBPDy9rGb4yGbc'}
                    }
                }
            ]
        },
        Auth: {
            identityPoolId: "us-east-1:62490b3c-81d4-4df5-8352-e0250a08d68a",
            region: "us-east-1",
            userPoolId: "us-east-1_TPjvx0Q4A",
            userPoolWebClientId: "5a13rk9eks6cibsebc1cv5j2ll",
            mandatorySignIn: true
        },
        Storage: {
            bucket: 'dev-a-userfiles',
            region: 'us-east-1',
        },
        Analytics: {
            disabled: true
        },
        oauth: {
            domain: 'dev.auth.rev-lock.com',
            clientId: '1092057117597-1nosea2ifka99fshkiqo4a4iajmjucq4.apps.googleusercontent.com',
            redirectSignOut: 'https://dev-a.rev-lock.com/signout',
            redirectSignIn: "https://dev-a.rev-lock.com/",
            scope: ['email', 'profile', 'openid'],
            responseType: "code"
        }
    },
    development: true
}
